
























































import { Component, Mixins } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";
import roles from "@/config/wow/roles";

import { getTimeSince } from "@/utils/date-helpers";
import { teamUrl } from "@/utils/url-helpers";
import { SYNC_ROSTERS_CHARACTERS_ITEMS_FAST_PERIOD } from "@/config/frequency-times";


/**
 * Components
 */
import SummaryTable from "./components/SummaryTable.vue";
import UsersRepartitionTable from "./components/UsersRepartitionTable.vue";

/**
 * API
 */
import rostersAPI from "@/api/rosters";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetRostersResponse } from "@/api/rosters/get-rosters.response";

/**
 * Mixins
 */
import mixinNow from "@/mixins/now-mixin";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * Types
 */


/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Team's dashboard page.
 */
@Component({
	components: {
		DataFetcher,
		SummaryTable,
		UsersRepartitionTable
	}
})
export default class DashboardPage extends Mixins(mixinNow) {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	roles = roles;
	armorTypes = armorTypes;

	getTimeSince = getTimeSince;
	teamUrl = teamUrl;


	/// Attributes
	isLoading = false;
	currentTabIndex = 0;
	tabs = [
		{
			name: "Summary",
		},
		{
			name: "Users"
		}
	];
	rosters: GetRostersResponse.Roster[] | null = null;


	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;


	/**
	 * One of the rosters.
	 */
	get oneOfTheRosters(): GetRostersResponse.Roster | null {
		return this.rosters && this.rosters.length > 0 ? this.rosters[0] : null;
	}

	/**
	 * Can the current roster be synchronized (updated / refreshed) ?
	 */
	get canSyncCurrentRoster(): boolean {
		return !this.isLoading && (this.oneOfTheRosters?.lastSync == null || (this.now.getTime() - Date.parse(this.oneOfTheRosters.lastSync)) > SYNC_ROSTERS_CHARACTERS_ITEMS_FAST_PERIOD);
	}

	/// Methods
	async created() {
		//this.isLoading = true;
		this.$teamHub.$on("team-sync", this.onTeamSync);
		//this.isLoading = false;
	}

	beforeDestroy() {
		this.$teamHub.$off("team-sync", this.onTeamSync);
	}

	async fetch() {
		await this.fetchRosters();
		await this.redirectToRosterRoute(this.$route);
	}

	async beforeRouteUpdate(to: Route, from: Route, next: NavigationGuardNext) {
		if (await this.redirectToRosterRoute(to)) {
			return;
		}
		next();
	}

	async redirectToRosterRoute(to: Route) {
		if (!to.params.rosterId && this.rosters && this.rosters.length > 0) {
			try {
				await this.$router.push(this.urlRosterButton(to, this.rosters[0].id));
			} catch (error) {

			}
			return true;
		}
		if (to.params.rosterId && this.rosters && this.rosters.length > 0 && this.rosters.find(x => x.id == to.params.rosterId) == null) {
			await this.$router.push("/teams");
			return true;
		}
		return false;
	}

	async fetchRosters() {
		this.rosters = await rostersAPI.fetchRosters(this.currentTeam.id);
	}

	async handleSyncClick() {
		this.isLoading = true;
		try {
			await rostersAPI.refreshAllRosters(this.currentTeam.id);
			await this.fetchRosters();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async onTeamSync() {
		await this.fetchRosters();
	}

	urlRosterButton(route: Route, rosterID: string) {
		const routePathSplit = route.path.split("/").filter(x => x != "");
		let subPath = "";
		if (route.params.rosterId) {
			// Case: already on a roster specific tracking page
			subPath = routePathSplit[routePathSplit.length - 2];
		}
		else {
			subPath = routePathSplit[routePathSplit.length - 1];
			if (subPath == "dashboard") {
				subPath = "overview";
			}
		}

		return teamUrl(this.currentTeam, `/dashboard/${subPath}/${rosterID}`);
	}
}
